// extracted by mini-css-extract-plugin
export var container = "EmployeeData-module--container--yLDGt";
export var ctas = "#226355";
export var grayBackground = "#f6f8fb";
export var name = "EmployeeData-module--name--IUB2F";
export var position = "EmployeeData-module--position--laJco";